import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface OriginPort {
  id: number;
  name: string;
  country: string | null;
}

export const useOriginPorts = () => {
  const [originPorts, setOriginPorts] = useState<OriginPort[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOriginPorts = async () => {
      try {
        const { data, error } = await supabase
          .from('booking_origin_port')
          .select('*')
          .order('name');

        if (error) throw error;
        setOriginPorts(data || []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch origin ports');
        console.error('Error fetching origin ports:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOriginPorts();
  }, []);

  return { originPorts, loading, error };
}; 